import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('customers-metadata', storeModule.createStoreModule('customers-metadata'))
